<template>
	<div id="part_report" v-if="showReport">
		<div class="car-report">
			<div class="section-title">权威认证 省心无忧</div>
			<div class="banner">
				<template v-if="car.basic.business_type === 1">
					<h1 class="title">蔚来官方认证报告</h1>
					<div class="subtitle">车辆已经通过蔚来286项专业检测</div>
				</template>
				<template v-else>
					<h1 class="title">权威第三方认证报告</h1>
					<div class="subtitle">车辆已经通过权威专业检测</div>
				</template>

				<div class="items">
					<div class="item">
						<nio-image class="icon" :src="IconFire" />
						无火烧车
					</div>
					<div class="item">
						<nio-image class="icon" :src="IconBattery" />
						电池正常
					</div>
					<div class="item">
						<nio-image class="icon" :src="IconWater" />
						无泡水车
					</div>
					<div class="item">
						<nio-image class="icon" :src="IconAccident" />
						无大事故
					</div>
				</div>
				<div
					class="btn"
					@click="previewReport"
					v-sd-exp:VehicleDetailExpo="{
						page: '二手车车辆详情页',
						label_name: car.$$track_label_name,
						tag: car.$$track_tags,
						module_name: '车辆官方认证报告',
						position_rank: 3,
						position_in_rank: 1,
						position_in_number: 1,
						track_sign: 'aMall.b4307.exposure.VehicleDetailExpo'
					}"
					v-sd-clk:VehicleDetailClick="{
						page: '二手车车辆详情页',
						label_name: car.$$track_label_name,
						tag: car.$$track_tags,
						module_name: '车辆官方认证报告',
						button_name: '查看完整报告',
						position_rank: 3,
						position_in_rank: 1,
						position_in_number: 1,
						track_sign: 'aMall.b4307.click.VehicleDetailClick'
					}"
				>
					查看完整报告
				</div>
			</div>
		</div>
		<nio-sheet
			v-model="showReportPicker"
			:closeable="true"
			buttonText="取消"
			@btnclick="() => (showReportPicker = false)"
			:style="{ paddingBottom: (safeAreaInsetBottom || 15) + 'px' }"
		>
			<div>
				<div v-for="action in actions" class="report" @click="clickHandle(action)">
					{{ action.name }}
				</div>
			</div>
		</nio-sheet>
	</div>
</template>

<script>
import _ from 'lodash'

import nativeHybrid from '@/util/nativeHybrid'
import ProcessCard from '@/views1/DetailPage/ProcessCard'
import { getSafeInsetBottom } from '@/util/unit-transfer'

import IconFire from '@/assets/svg/icon_fire.svg'
import IconWater from '@/assets/svg/icon_water.svg'
import IconBattery from '@/assets/svg/icon_battery.svg'
import IconAccident from '@/assets/svg/icon_accident.svg'

const previewPDF = _.debounce(url => {
	nativeHybrid.showLoading()
	nativeHybrid.openPDF(url + `${url.indexOf('?') > -1 ? '&' : '?'}title=`).then(() => {
		nativeHybrid.hideLoading()
	})
})
export default {
	name: 'CarReport',
	props: ['car'],
	data() {
		return {
			showReportPicker: false,
			IconFire,
			IconWater,
			IconAccident,
			IconBattery,
			safeAreaInsetBottom: getSafeInsetBottom()
		}
	},
	components: {
		ProcessCard
	},
	computed: {
		showReport() {
			const basic = this.car.basic
			const detectReports = basic.detect_reports
			//增加一个逻辑 临时下掉官方报告
			if(this.car.basic.business_type === 1){
				return false
			}
			return [1, 4].includes(basic.business_type) && detectReports && detectReports.length
		},
		title() {
			if (this.car.basic.business_type === 1) {
				return '车辆认证报告'
			} else {
				return '车辆已通过专业检测'
			}
		},
		moduleName() {
			if (this.car.basic.business_type === 1) {
				return '认证报告'
			} else {
				return '检测报告'
			}
		},
		actions() {
			if (this.car && this.car.basic) {
				let detectReports = this.car.basic.detect_reports || []
				const realDetectReports = detectReports.filter(
					detectReport => detectReport.type !== 'authority'
				)
				const authorityDetectReports = detectReports.filter(
					detectReport => detectReport.type === 'authority'
				)
				return [
					...realDetectReports.map((item, index) => {
						return {
							name: `实车检测报告${index + 1}`,
							url: item.url
						}
					}),
					...authorityDetectReports.map((item, index) => {
						return {
							name: `三方权威报告${index + 1}`,
							url: item.url
						}
					})
				]
			}
			return []
		}
	},
	methods: {
		previewReport() {
			if (this.car && this.car.basic) {
				const detectReports = this.car.basic.detect_reports || []
				if (detectReports.length) {
					if (detectReports.length > 1) {
						this.showReportPicker = true
					} else {
						previewPDF(detectReports[0].url)
					}
				} else {
					nativeHybrid.showToast('暂无认证报告')
				}
			}
		},
		clickHandle(item) {
			previewPDF(item.url)
			this.showReportPicker = false
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.car-report {
	margin-top: 60px;

	.section-title {
		@include subtitle_1(1.4, 400, false);
		color: $text_primary;
		margin-bottom: 20px;
	}

	.banner {
		width: 335px;
		height: 286px;
		background-image: url(https://cdn-fx.nio.com/fx/second-hand-app-pkg/__cdn__/detect_report.png);
		background-size: contain;
		background-repeat: no-repeat;
		// opacity: 0.3;
		padding: 34px 20px 0;
		.title {
			font-size: 20px;
			color: #050b27;
		}
		.subtitle {
			font-size: 12px;
			color: #050b27;
			opacity: 0.4;
		}
	}

	.items {
		display: flex;
		// padding: 0 10px;
		margin: 50px 0 30px;
		.item {
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			font-size: 12px;
			color: #686d82;
			.icon {
				margin-bottom: 6px;
			}
		}
	}

	.btn {
		padding: 10px 0;
		font-size: 16px;
		color: #050b27;
		text-align: center;
		background-color: #fff;
	}
}
.report {
	padding: 15px 0;
	font-size: 16px;
	color: rgba(5, 11, 39, 1);
	text-align: center;
}
</style>
